(function () {
  var CLOSED_TEXT = 'Menu';
  var OPEN_TEXT   = 'Close';

  function isOpen(siteNav) {
    if (!siteNav) return false;

    // 1) ARIA
    var ariaHidden = siteNav.getAttribute('aria-hidden');
    if (ariaHidden === 'false') return true;

    // 2) Computed display
    try {
      var cs = window.getComputedStyle(siteNav);
      if (cs && cs.display !== 'none' && cs.visibility !== 'hidden' && cs.opacity !== '0') {
        return true;
      }
    } catch (e) {}

    // 3) Common theme classes that imply open
    if (siteNav.classList.contains('site-nav__submenu--expanded')) return true;
    if (document.body.classList.contains('js-drawer-open')) return true;

    return false;
  }

  function updateLabel(btn, label, siteNav) {
    if (!btn || !label) return;
    var open = isOpen(siteNav);

    // If the theme never sets aria-expanded, keep it in sync ourselves (harmless)
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    label.textContent = open ? OPEN_TEXT : CLOSED_TEXT;
  }

  function bind() {
    var btn = document.getElementById('ToggleMobileMenu');
    if (!btn) return;

    var label = btn.querySelector('.icon__fallback-text');
    var siteNav = document.getElementById('SiteNav');

    if (!label) return;

    // Initial label
    updateLabel(btn, label, siteNav);

    // Update on button clicks (theme toggles after click; small delay)
    btn.addEventListener('click', function () {
      setTimeout(function(){ updateLabel(btn, label, siteNav); }, 50);
    });

    // Observe SiteNav attribute/class/style changes
    if (siteNav) {
      try {
        new MutationObserver(function () {
          updateLabel(btn, label, siteNav);
        }).observe(siteNav, {
          attributes: true,
          attributeFilter: ['class', 'style', 'aria-hidden']
        });
      } catch (e) {}
    }

    // Observe body class flips (many themes toggle body on drawer open)
    try {
      new MutationObserver(function () {
        updateLabel(btn, label, siteNav);
      }).observe(document.body, {
        attributes: true,
        attributeFilter: ['class']
      });
    } catch (e) {}

    // Also refresh on window resize (mobile/desktop transitions)
    window.addEventListener('resize', function () {
      updateLabel(btn, label, siteNav);
    });
  }

  // Bind on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }

  // Re-bind when Shopify dynamically reloads sections
  document.addEventListener('shopify:section:load', bind);
})();
